/**
 * main，程序 入口
 *
 *  * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import moment from 'moment';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./common/js/http";
import webapi from "./common/js/api";
import MintUI from "mint-ui";
import 'mint-ui/lib/style.css'

import components from "./components";

import filters from "./common/js/filter";
// import vconsole from 'vconsole'
// var vco = new vconsole()
import {
  clog,
  formatDateTime2,
  formatDateTime3,
  thousandBitSeparator
} from "./common/js/common";

import { routerNames } from "./common/js/const";

// vux 引入组件
import {
  AlertPlugin,
  ToastPlugin,
  dateFormat,
  DatetimePlugin,
  ConfirmPlugin,
  querystring,
  LoadingPlugin
} from "xf-vux";

// 实例化Vue的filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.use(AlertPlugin);
Vue.use(LoadingPlugin);
Vue.use(ToastPlugin);
Vue.use(MintUI);
Vue.use(components);

// 默认参数
// Vue.use(ToastPlugin, {position: 'top'})
Vue.use(DatetimePlugin);
Vue.use(ConfirmPlugin);

// import VuePreview from 'vue-preview'
// // defalut install
// // Vue.use(VuePreview)
// // with parameters install
// Vue.use(VuePreview, {
//   mainClass: 'pswp--minimal--dark',
//   barsSize: {top: 0, bottom: 0},
//   captionEl: false,
//   fullscreenEl: false,
//   shareEl: false,
//   bgOpacity: 0.85,
//   tapToClose: true,
//   tapToToggleControls: false
// })

Vue.config.productionTip = false;

// 引入微信插件
// import {
//   WechatPlugin
// } from 'vux'
// Vue.use(WechatPlugin)
// console.log(Vue.wechat) // 可以直接访问 wx 对象
/**
 * 那么之后任何组件中都可以通过 this.$wechat 访问到 wx 对象。
考虑到你需要在引入插件后调用wx.config方法进行配置，你可以通过 Vue.wechat 在组件外部访问wx对象。
jssdk需要请求签名配置，你可以直接使用下面的ajaxPlugin。
 */

// axios封装
Vue.use(http);
// api封装   在vue中  调用的时候 用 this.$webapi.deleteInvoiceTitle(....)
Vue.use(webapi);

// // 解决点击延迟
// var FastClick = require('fastclick')
// FastClick.attach(document.body)

// 注册全局的方法
regGlobalMethod();
global.bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: {
    App
  }
});

/**
 * 注册全局的方法
 *
 * 在视图中 可以 用  this.$clog('xxxx')
 */
function regGlobalMethod() {
  Vue.prototype.$routerNames = routerNames;

  Vue.prototype.$querystring = querystring;

  Vue.prototype.$dateFormat = dateFormat;

  Vue.prototype.$clog = clog;

  // 20180402115522格式的时间格式化
  Vue.prototype.$formatDateTime2 = formatDateTime2;

  // 20180402格式的时间格式化
  Vue.prototype.$formatDateTime3 = formatDateTime3;
  // 金额千分位且保留两位小数
  Vue.prototype.$thousandBitSeparator = thousandBitSeparator;

  Vue.prototype.$cerr = function($msg) {
    var str = clog($msg, "ERR");
    return str;
  };

  Vue.filter('datetimeformat', function(dataStr) {
    return dataStr ? moment(dataStr).format('YYYY-MM-DD HH:mm:ss') : '';
  })

}
